import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["PublicationsList"] */ "/vercel/path0/src/features/publications/components/publications-list/publications-list.tsx");
